/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import { BulletList } from 'react-content-loader'

import '../ShopList/list.scss'

import { ToRial } from '../../services/toRial'

export default function index(data) {
  const [settings, setSettings] = useState([])

  useEffect(() => {
    setSettings(data.data)
  }, [data])

  return (
    <>
      <table className='table'>
        <thead>
          <tr>
            <th>نام رستوران</th>
            <th>شعبه</th>
            <th>هزینه ارسال</th>
            <th>حداقل سفارش</th>
          </tr>
        </thead>
        <tbody>
          {settings ? settings.map(item => (
              <tr key={item._id}>
                <td>{item.mainName}</td>
                <td>{item.branch[0].name}</td>
                <td>{ToRial(String(item.shippingCost)) + ' تومان '}</td>
                <td>{ToRial(String(item.minimumOrder)) + ' تومان '}</td>
              </tr>
            )) : <tr><td colSpan="5"><BulletList rtl style={{ width: '30%', rowspan: '5' }}/></td></tr>}
        </tbody>
      </table>
    </>
  );
}
